import Vue from 'vue'
import {AclCreate, AclInstaller, AclRule} from 'vue-acl'
import router from '@/router'
import {ROLES_KEY} from "@/graphql";

Vue.use(AclInstaller)
let initialRole = 'guest'
// alert(initialRole)

let user_roles = []
let user_roles_array = []

const userRoles = JSON.parse(localStorage.getItem('user-roles'))

if (Array.isArray(userRoles)) initialRole = userRoles[0].name

console.log(initialRole)

let setUserRoles = {
  guest: new AclRule('user').or('manager').or('kvsupport').or('center').or('admin').or('guest').generate(),
  user: new AclRule('user').or('manager').or('kvsupport').or('center').or('admin').generate(),
  manager: new AclRule('manager').or('kvsupport').or('center').or('admin').generate(),
  kvsupport: new AclRule('kvsupport').or('center').or('admin').generate(),
  center: new AclRule('center').or('admin').generate(),
  admin: new AclRule('admin').generate(),

}

export default new AclCreate({
  initial: initialRole,
  notfound: '/login',
  router,
  acceptLocalRules: true,

  globalRules: setUserRoles
})
